// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t2-0";
export var checkoutRateBadgeLink = "_t2-1";